'use strict';

import 'google';

import sharedMapStyles from './sharedMapStyles';

const RECENT_CHECKIN_MS = 1000 * 60 * 15;
const STALE_CHECKIN_MS = 1000 * 60 * 30;
const USELESS_CHECKIN_MS = 1000 * 60 * 60 * 1;

function getUrlParameter(name) {
  name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
  // nosemgrep
  var regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
  var results = regex.exec(location.search);
  return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
};


function updateOrPushByAttr(arr, el, id_attr) {
  for (var i = 0; i < arr.length; i++) {
    const x = arr[i];
    if (x[id_attr] === el[id_attr]) {
      arr[i] = el;
      return;
    }
  }
  arr.push(el);
}


function deleteByByAttr(arr, el, id_attr) {
  for (var i = 0; i < arr.length; i++) {
    const x = arr[i];
    if (x[id_attr] === el[id_attr]) {
      arr.splice(i, 1);
      return;
    }
  }
}


export default function ($timeout, $compile, $location) {
  'ngInject';

  return {
    scope: {
      internalName: '@',
      lat: '<',
      lng: '<',
      designations: '<',
      undispatchedVersions: '<',
      dispatchVersions: '<',
      mapStyles: '<',
    },
    link: {
      pre: preLink,
    },
    controller: controller,
    controllerAs: '$dispatchCtrl',
    transclude: true,
  }

  function preLink(scope, element, attrs, ctrl, transclude) {
    if (scope.lat === undefined) {
      // Kansas City...
      scope.lat = 39.08694473181338;
      scope.lng = -94.58585807640969;
    }
    transclude(scope, function (clone, scope) {
      element.append(clone);
      const mapElement = element[0].querySelector('#dispatch-map');
      ctrl.map = new google.maps.Map(mapElement, {
        zoom: 10,
        center: { lat: scope.lat, lng: scope.lng },
        mapTypeId: 'roadmap',
        mapTypeControl: false,
        scaleControl: false,
        streetViewControl: true,
        rotateControl: false,
        fullscreenControl: false,
        styles: scope.mapStyles || sharedMapStyles,
      });
      function checkMapMuddiness() {
        if (ctrl.mapInitialized && !ctrl.resettingMap && !ctrl.dirtyMap) {
          console.log('Marking map as dirty');
          $timeout(() => {
            ctrl.dirtyMap = true;
          }, 0);
        }
      }
      ctrl.map.addListener('zoom_changed', checkMapMuddiness);
      ctrl.map.addListener('bounds_changed', checkMapMuddiness);
      ctrl.map.addListener('center_changed', checkMapMuddiness);
    });
  }

  function controller($http, $timeout, $filter, $scope, pusher, toastr) {
    'ngInject';

    var vm = this;
    vm.mapInitialized = false;
    vm.dirtyMap = false;
    vm.incidentMarkers = {};
    vm.crewMarkers = {};
    vm.crewData = {};
    vm.unlocatedIncidents = [];
    vm.focusedIncident = getUrlParameter('fi');
    vm.openedFocusedIncident = false;

    function updateThresholdDates() {
      vm.thresholds = {
        checkinRecent: new Date(new Date() - RECENT_CHECKIN_MS),
        checkinStale: new Date(new Date() - STALE_CHECKIN_MS),
        checkinUseless: new Date(new Date() - USELESS_CHECKIN_MS),
        managerNote: new Date(new Date() - 1000 * 60 * 60 * 12),
      };
      $timeout(updateThresholdDates, 1000 * 60);
    }
    updateThresholdDates()

    function processCrewNote(crew) {
      if (crew.note) {
        crew.note.customBody = crew.note.body;
        crew.note.time = new Date(crew.note.time);
      }
    }

    function processCrewCheckin(crew) {
      if (crew.checkin) {
        crew.checkin.time = new Date(crew.checkin.time);
        if (vm.crewMarkers[crew.id]) {
          vm.crewMarkers[crew.id].setMap(null);
          delete vm.crewMarkers[crew.id];
        }
        if (!crew.active) return;
        if (!crew.checkin.point) return;
        const point = { lat: crew.checkin.point[0], lng: crew.checkin.point[1] };
        const score = 1 - (new Date() - crew.checkin.time) / USELESS_CHECKIN_MS;
        if (score > 0) {
          console.log('Truck score', score);
          const marker = new google.maps.Marker({
            position: point,
            map: vm.map,
            icon: {
              url: '/static/daupler/img/local_shipping-24px.svg',
              labelOrigin: new google.maps.Point(10, -8),
            },
            animation: google.maps.Animation.DROP,
            opacity: Math.max(0.2, score),
            zIndex: 3000,
            label: {
              text: crew.name,
              fontWeight: 'bold',
              fontSize: '16px',
            },
          });
          const displayTime = $filter('date')(crew.checkin.time, 'h:mm a');
          if (crew.note && crew.note.body) {
            const infoWindow = new google.maps.InfoWindow({
              content: `
						<div class="map-window">
							<strong>${crew.name}</strong> &middot; <strong>${displayTime}</strong>
							<br>
							${crew.checkin.note}
						</div>`,
            });
            marker.addListener('click', function () {
              infoWindow.open(vm.map, marker);
            });
          } else {
            const infoWindow = new google.maps.InfoWindow({
              content: `
						<div class="map-window">
							<strong>${crew.name}</strong> &middot; <strong>${displayTime}</strong>
						</div>`,
            });
            marker.addListener('click', function () {
              infoWindow.open(vm.map, marker);
            });
          }
          vm.crewMarkers[crew.id] = marker;
        }
      }
    }

    function processIncident(incident) {
      let undispatched = ($scope.undispatchedVersions.indexOf(incident.version) >= 0);
      incident.dispatched = !undispatched;
      if (vm.incidentMarkers[incident.uuid]) {
        vm.incidentMarkers[incident.uuid].setMap(null);
      }
      if (!incident.point) {
        if (undispatched) {
          updateOrPushByAttr(vm.unlocatedIncidents, incident, 'uuid');
        }
        return;
      }
      deleteByByAttr(vm.unlocatedIncidents, incident, 'uuid');
      const point = { lat: incident.point[0], lng: incident.point[1] };
      const displayTime = $filter('date')(incident.time, "M/d '&middot;' h:mm a");
      const targetVersion = incident.target_version || '';
      const content = `
					<div class="map-window">
					<strong>${displayTime}</strong>
					<br>
					<br>
					${incident.description}
					<br>
					<br>
					<div class="text-right">
					<div class="btn-group btn-group-sm">
					<a
						ng-if="${undispatched}"
						beta-manual-dispatch
						context="{
						incident: '${incident.uuid}',
						crew: $dispatchCtrl.data.crew,
						versions: dispatchVersions,
            targetVersion: '${targetVersion}',
						}"
						href=""
						class="btn btn-primary"
						style="
						font-weight: bold;
						"
					>
					Dispatch
					</a>
					<a
						href="/incident/${incident.uuid}/"
						target="_blank"
						class="btn btn-default"
						style="
						font-weight: bold;
						"
					>
					Incident details
					<i class="material-icons">open_in_new</i>
					</a>
					</div>
					</div>
					</div>`;
      const infoWindow = new google.maps.InfoWindow({
        content: $compile(content)($scope)[0],
      });
      const marker = new google.maps.Marker({
        position: point,
        map: vm.map,
        animation: google.maps.Animation.DROP,
        opacity: undispatched ? 1 : 0.4,
        zIndex: undispatched ? 1001 : 1000,
      });
      marker.addListener('click', function () {
        infoWindow.open(vm.map, marker);
      });
      if (!vm.openedFocusedIncident && incident.uuid === vm.focusedIncident) {
        vm.openedFocusedIncident = true;
        infoWindow.open(vm.map, marker);
      }
      vm.incidentMarkers[incident.uuid] = marker;
    }

    function resetMap() {
      if (vm.mapInitialized && vm.dirtyMap) return;
      console.log('Resetting map');
      vm.resettingMap = true;
      try {
        let boundsExtended = false;
        const bounds = new google.maps.LatLngBounds();
        for (var key in vm.incidentMarkers) {
          if (vm.incidentMarkers.hasOwnProperty(key)) {
            bounds.extend(vm.incidentMarkers[key].getPosition());
            boundsExtended = true;
          }
        }
        for (var key in vm.crewMarkers) {
          if (vm.crewMarkers.hasOwnProperty(key)) {
            bounds.extend(vm.crewMarkers[key].getPosition());
            boundsExtended = true;
          }
        }
        if (boundsExtended) {
          vm.map.fitBounds(bounds);
          if (vm.map.getZoom() > 16) vm.map.setZoom(16);
          // else vm.map.setZoom(vm.map.getZoom() - 1);
        }
      } finally {
        vm.mapInitialized = true;
        $timeout(() => {
          console.log('Finished resetting map');
          vm.resettingMap = false;
        }, 0);
      }
    }

    function updateMapMarkers() {
      for (var crewName in vm.crewMarkers) {
        if (vm.crewMarkers.hasOwnProperty(crewName) && vm.crewData.hasOwnProperty(crewName)) {
          const crew = vm.crewData[crewName];
          const score = 1 - (new Date() - crew.checkin.time) / USELESS_CHECKIN_MS;
          if (score > 0) {
            vm.crewMarkers[crew.id].setOpacity(score);
          } else {
            console.log('Removing useless checkin from map');
            vm.crewMarkers[crew.id].setMap(null);
            delete vm.crewMarkers[crew.id];
            resetMap();
          }
        }
      }
      $timeout(updateMapMarkers, 1000 * 60);
    }
    updateMapMarkers();

    vm.resetMap = function () {
      if (!vm.dirtyMap || vm.resettingMap) return;
      vm.dirtyMap = false;
      resetMap(true);
    }

    function processDispatchData() {
      vm.manual_mode = vm.data.manual_mode;

      for (const crew of vm.data.crew) {
        processCrewNote(crew);
        processCrewCheckin(crew);
        vm.crewData[crew.id] = crew;
      }
      for (const incident of vm.data.incidents) {
        processIncident(incident);
      }
      resetMap();
    }

    function fetchDispatchData() {
      const designations = $scope.designations.join(',');
      const url = new URL('/api/beta/dispatch/get-data/', document.baseURI);
      url.searchParams.append('e', $scope.internalName);
      url.searchParams.append('d', designations);
      $http.get(url.href).then((response) => {
        console.log(response.data);
        vm.data = response.data;
        processDispatchData();
      }).finally(() => {
        vm.loadedData = true;
      });
    }

    // Update manual mode
    vm.updateManualModeStatus = function () {
      const enabled = vm.manual_mode;
      if (!enabled && !confirm('Are you sure you want to disable manual mode?')) {
        vm.manual_mode = true;
        return;
      }
      if (enabled && !confirm('Are you sure you want to enable manual mode?')) {
        vm.manual_mode = false;
        return;
      }
      const data = {
        entity: $scope.internalName,
        enabled: enabled,
      };
      if (vm.updating) return;
      vm.updating = true;
      $http.post('/api/beta/dispatch/update-manual-mode-status/', data).then((response) => {
        vm.manual_mode = enabled;
      }, (error) => {
        if (enabled) toastr.error('Could not enable manual mode');
        if (!enabled) toastr.error('Could not disable manual mode');
        vm.manual_mode = !enabled;
      }).finally(() => {
        vm.updating = false;
      })
    }

    // Update note
    vm.updateNote = function (crew) {
      const data = {
        entity: $scope.internalName,
        designation: crew.id,
        body: crew.note.customBody,
      };
      if (vm.updating) return;
      vm.updating = true;
      $http.post('/api/beta/dispatch/update-note/', data).then((response) => {
        crew.note.body = data.body;
        crew.note.time = new Date();
      }, (error) => {
        console.log(error);
        toastr.error('Could not update note for ' + crew.name);
      }).finally(() => {
        vm.updating = false;
      });
    }

    // Update active status
    vm.updateActiveStatus = function (crew, value) {
      const data = {
        entity: $scope.internalName,
        designation: crew.id,
        active: value,
      };
      if (vm.updating) return;
      vm.updating = true;
      $http.post('/api/beta/dispatch/update-active-status/', data).then((response) => {
        crew.active = value;
      }, (error) => {
        toastr.error('Could not update active status for ' + crew.name);
      }).finally(() => {
        vm.updating = false;
      });
    }

    // Request checkins
    vm.requestCheckins = function () {
      const selectedDesignations = vm.data.crew.filter(c => c.selected).map(c => c.id);
      vm.updating = true;
      const data = {
        entity: $scope.internalName,
        designations: selectedDesignations,
      };
      $http.post('/api/beta/dispatch/initiate-checkins/', data).then((response) => {
        console.log(response);
        vm.cancelSelection();
      }, (error) => {
        console.log(error);
        toastr.error('An error occurred requesting checkins');
      }).finally(() => {
        // Nothing for now...
        vm.updating = false;
      });
    }

    // Handle live updates
    let channel = pusher.subscribe('presence-entity-' + $scope.internalName + '-dispatch');
    channel.bind_global(function (event, data) {
      console.log('Dispatch event received:', event, data);
    });

    channel.$bind('pusher:subscription_succeeded', function (data) {
      fetchDispatchData();
    });

    channel.$bind('MANUAL_MODE_UPDATED', function (data) {
      if (data.enabled) toastr.success('Manual mode has been enabled');
      if (!data.enabled) toastr.success('Manual mode has been disabled');
      vm.manual_mode = data.enabled;
    });

    channel.$bind('CHECKIN_COMPLETED', function (data) {
      toastr.success(data.designation + ' just checked in.');
      if (!vm.data.crew) return;
      for (const crew of vm.data.crew) {
        if (crew.id === data.designation) {
          crew.checkin = data.checkin;
          processCrewCheckin(crew);
          resetMap();
          break;
        }
      }
    });

    channel.$bind('CHECKIN_FAILED', function (data) {
      toastr.error(data.designation + ' failed to check in.');
      if (!vm.data.crew) return;
      for (const crew of vm.data.crew) {
        if (crew.id === data.designation) {
          crew.checkin = data.checkin;
          processCrewCheckin(crew);
          break;
        }
      }
    });

    channel.$bind('NOTE_UPDATED', function (data) {
      if (!vm.data.crew) return;
      toastr.success('Note for ' + data.designation + ' updated by ' + data.note.source);
      for (const crew of vm.data.crew) {
        if (crew.id === data.designation) {
          crew.note = data.note;
          processCrewNote(crew);
          break;
        }
      }
    });

    channel.$bind('ACTIVE_STATUS_UPDATED', function (data) {
      if (!vm.data.crew) return;
      if (data.active) toastr.success(data.designation + ' has been marked as active.');
      if (!data.active) toastr.success(data.designation + ' has been marked as inactive.');
      for (const crew of vm.data.crew) {
        if (crew.id === data.designation) {
          crew.active = data.active;
          processCrewCheckin(crew);
          resetMap();
          break;
        }
      }
    });

    channel.$bind('INCIDENT_UPDATED', function (data) {
      if (!vm.data.incidents) return;
      let onList = false;
      for (const incident of vm.data.incidents) {
        if (incident.uuid === data.uuid) {
          const pointUpdated = (
            (incident.point && !data.point) ||
            (!incident.point && data.point) ||
            (incident.point[0] !== data.point[0])
          );
          Object.assign(incident, data)
          processIncident(incident);
          onList = true;
          if (pointUpdated) resetMap();
          break;
        }
      }
      if (!onList) {
        const isUndispatched = $scope.undispatchedVersions.indexOf(data.version) >= 0;
        if (data.created && isUndispatched) toastr.success('A new incident was reported.')
        vm.data.incidents.push(data);
        processIncident(data);
        resetMap();
      }
    });

    channel.$bind('INCIDENT_NOT_ACTIVE', function (data) {
      const oldLength = vm.data.incidents.length;
      vm.data.incidents = vm.data.incidents.filter((i) => i.uuid !== data.uuid);
      const newLength = vm.data.incidents.length;
      if (oldLength > newLength) {
        toastr.success('An incident was completed.');
      }
      if (vm.incidentMarkers[data.uuid]) {
        vm.incidentMarkers[data.uuid].setMap(null);
        delete vm.incidentMarkers[data.uuid];
        resetMap();
      }
      deleteByByAttr(vm.unlocatedIncidents, data, 'uuid');
    });

    channel.$bind('CHECKINS_REQUESTED', function (data) {
      if (!vm.data.crew) return;
      toastr.success('Initiated ' + data.designations.length + ' check-in(s).');
      for (const crew of vm.data.crew) {
        if (data.designations.indexOf(crew.id) >= 0) {
          if (!crew.checkin) crew.checkin = {};
          crew.checkin.status = 'IN_PROGRESS';
        }
      }
    });

    vm.initiateSelection = function () {
      for (var d of vm.data.crew) {
        d.selected = false;
      }
      vm.selectingForCheckIn = true;
      vm.selectAll = false;
    }
    vm.cancelSelection = function () {
      vm.selectingForCheckIn = false;
      vm.selectAll = false;
    }

    vm.toggleSelectAll = function (value) {
      for (var d of vm.data.crew) {
        if ((!d.checkin || d.checkin.status != 'IN_PROGRESS') && d.designated_user && d.active) {
          d.selected = value;
        }
      }
    }
  }
}
